/* eslint-disable react/prop-types */
import axios from 'axios';
import Cookies from 'js-cookie';
import { debounce } from 'lodash';
import { FieldArray } from 'formik';
import { useTranslation } from 'react-i18next';
import React, { useCallback, useEffect, useState } from 'react';
// api
import ApiKey from '../../../api/ApiKey';
import BaseApi from '../../../api/BaseApi';
// components
import Input from '../../components/Input';
import Select from '../../components/Select';
import InputCheckbox from '../../components/InputCheckbox';
import AsyncSelectReact from '../../components/AsyncSelectReact';
import SelectWithIdInOptions from '../../components/SelectWithIdInOptions';
import SelectReactWithTextManualEntry from '../../components/SelectReactWithTextManualEntry';
// helpers
import { debounceAsync } from '../../../helpers';
// hooks
import { useWindowSize } from '../../../../Hooks/use-window-size';

const transformArray = inputArray => inputArray.map(item => ({
  name: item.name,
  id: item.value,
}));

const AdditionalEducationComponent = ({
  t,
  push,
  index,
  addEdu,
  errors,
  months,
  remove,
  touched,
  yearList,
  handleChange,
  handleAddItem,
  setFieldValue,
  setFieldTouched,
  handleFileRemove,
  handleFileUpload,
  handleRemoveItem,
  additional_educations,
}) => {
  const [diploma, setDiploma] = useState(addEdu.diploma_type || '');
  const [courseLink, setCourseLink] = useState(addEdu.course_link || '');
  const [courseName, setCourseName] = useState(addEdu.course_name || '');
  const [institution, setInstitution] = useState(addEdu.institution_add || '');

  const handleInputChange = useCallback((e, index) => {
    const { name, value } = e.target;

    const cleanName = name.replace(`additional_educations[${index}].`, '');

    if (cleanName === 'course_name') {
      setCourseName(value);
    } else if (cleanName === 'institution_add') {
      setInstitution(value);
    } else if (cleanName === 'diploma_type') {
      setDiploma(value);
    } else {
      setCourseLink(value);
    }

    debouncedHandleInputChange(name, value);
  }, []); // eslint-disable-line

  const debouncedHandleInputChange = debounce((name, value) => {
    setFieldValue(name, value);
  }, 500);

  return (
    <div key={index}>
      <Input
        value={courseName}
        label={t('jobseekerEditProfile.courseName')}
        className={`${index === 0 ? 'mt-4' : 'mt-5'}`}
        handleChange={e => handleInputChange(e, index)}
        placeholder={t('jobseekerEditProfile.courseName')}
        name={`additional_educations[${index}].course_name`}
        error={errors?.additional_educations?.[index]?.course_name}
        touched={touched?.additional_educations?.[index]?.course_name}
        errorMessage={errors?.additional_educations?.[index]?.course_name}
        handleBlur={() => setFieldTouched(`additional_educations[${index}].course_name`, true)}
      />
      <Input
        value={institution}
        label={t('jobseekerEditProfile.institution')}
        handleChange={e => handleInputChange(e, index)}
        placeholder={t('jobseekerEditProfile.institution')}
        name={`additional_educations[${index}].institution_add`}
        error={errors?.additional_educations?.[index]?.institution_add}
        touched={touched?.additional_educations?.[index]?.institution_add}
        errorMessage={errors?.additional_educations?.[index]?.institution_add}
        handleBlur={() => setFieldTouched(`additional_educations[${index}].institution_add`, true)}
      />
      <Input
        value={diploma}
        label={t('jobseekerEditProfile.documentName')}
        handleChange={e => handleInputChange(e, index)}
        placeholder={t('jobseekerEditProfile.documentName')}
        name={`additional_educations[${index}].diploma_type`}
        error={errors?.additional_educations?.[index]?.diploma_type}
        touched={touched?.additional_educations?.[index]?.diploma_type}
        errorMessage={errors?.additional_educations?.[index]?.diploma_type}
        handleBlur={() => setFieldTouched(`additional_educations[${index}].diploma_type`, true)}
      />
      <Input
        value={courseLink}
        label={t('jobseekerEditProfile.courseLink')}
        handleChange={e => handleInputChange(e, index)}
        placeholder={t('jobseekerEditProfile.courseLink')}
        name={`additional_educations[${index}].course_link`}
        error={errors?.additional_educations?.[index]?.course_link}
        touched={touched?.additional_educations?.[index]?.course_link}
        errorMessage={errors?.additional_educations?.[index]?.course_link}
        handleBlur={() => setFieldTouched(`additional_educations[${index}].course_link`, true)}
      />
      <div className='form-outline mb-4 DashBoardInputBx'>
        <label
          className='form-label'
          id={`additional_educations[${index}].certificate`}
          htmlFor={`additional_educations[${index}].certificate`}
        >
          {t('jobseekerEditProfile.certificate')}
        </label>
        <input
          type='file'
          accept='.jpeg, .png, .jpg'
          onChange={e => handleFileUpload(e, index)}
          name={`additional_educations[${index}].certificate`}
          onBlur={() => setFieldTouched(`additional_educations[${index}].certificate`, true)}
          className={
            `form-control ${touched?.additional_educations?.[index]?.certificate && errors?.additional_educations?.[index]?.certificate && 'input-error'}`
          }
        />
        {
          touched?.additional_educations?.[index]?.certificate && errors?.additional_educations?.[index]?.certificate && (
            <div className='text-danger'>{errors.additional_educations[index]?.certificate}</div>
          )
        }
      </div>
      {
        addEdu.certificate && !addEdu.certificate.endsWith('/') && (
          <div className='JSEPFirstSegment mx-0 mt-0 mb-4'>
            <div className='profileImageBox'>
              <img
                alt='certificate'
                src={addEdu.certificate}
                className='profileImage'
              />
            </div>
            <button
              type='button'
              className='btn btn-primary button1'
              onClick={() => handleFileRemove(index)}
            >
              {t('jobseekerEditProfile.removeButton')}
            </button>
          </div>
        )
      }
      <div className='form-outline mb-4 DashBoardInputBx'>
        <div className='row'>
          <div className='col-lg-6'>
            <p className='mb-4'>
              {t('jobseekerEditProfile.startOfEducation')}
            </p>
            <div className='row'>
              <SelectWithIdInOptions
                options={months}
                className='col-lg-6'
                value={addEdu.from_month_edu_add}
                label={t('jobseekerEditProfile.month')}
                handleChange={e => handleChange(e, index)}
                defaultOption={t('jobseekerEditProfile.selectMonth')}
                name={`additional_educations[${index}].from_month_edu_add`}
                required={addEdu.from_month_edu_add || addEdu.from_year_edu_add}
                error={errors?.additional_educations?.[index]?.from_month_edu_add}
                touched={touched?.additional_educations?.[index]?.from_month_edu_add}
                errorMessage={errors?.additional_educations?.[index]?.from_month_edu_add}
                handleBlur={() => setFieldTouched(`additional_educations[${index}].from_month_edu_add`, true)}
              />
              <Select
                options={yearList}
                className='col-lg-6'
                value={addEdu.from_year_edu_add}
                label={t('jobseekerEditProfile.year')}
                handleChange={e => handleChange(e, index)}
                defaultOption={t('jobseekerEditProfile.selectYear')}
                name={`additional_educations[${index}].from_year_edu_add`}
                required={addEdu.from_month_edu_add || addEdu.from_year_edu_add}
                error={errors?.additional_educations?.[index]?.from_year_edu_add}
                touched={touched?.additional_educations?.[index]?.from_year_edu_add}
                errorMessage={errors?.additional_educations?.[index]?.from_year_edu_add}
                handleBlur={() => setFieldTouched(`additional_educations[${index}].from_year_edu_add`, true)}
              />
            </div>
          </div>
          <div className='col-lg-6'>
            <p className='mb-4'>
              {t('jobseekerEditProfile.endOfEducation')}
            </p>
            <div className='row'>
              <SelectWithIdInOptions
                options={months}
                className='col-lg-6'
                value={addEdu.to_month_edu_add}
                label={t('jobseekerEditProfile.month')}
                defaultOption={t('jobseekerEditProfile.selectMonth')}
                name={`additional_educations[${index}].to_month_edu_add`}
                error={errors?.additional_educations?.[index]?.to_month_edu_add}
                touched={touched?.additional_educations?.[index]?.to_month_edu_add}
                errorMessage={errors?.additional_educations?.[index]?.to_month_edu_add}
                handleBlur={() => setFieldTouched(`additional_educations[${index}].to_month_edu_add`, true)}
                required={
                  (addEdu.from_month_edu_add || addEdu.from_year_edu_add || addEdu.to_month_edu_add || addEdu.to_year_edu_add) && !addEdu.still_learning_add
                }
                handleChange={e => {
                  handleChange(e, index);
                  setFieldValue(`additional_educations[${index}].still_learning_add`, false);
                }}
              />
              <Select
                options={yearList}
                className='col-lg-6'
                value={addEdu.to_year_edu_add}
                label={t('jobseekerEditProfile.year')}
                defaultOption={t('jobseekerEditProfile.selectYear')}
                name={`additional_educations[${index}].to_year_edu_add`}
                error={errors?.additional_educations?.[index]?.to_year_edu_add}
                touched={touched?.additional_educations?.[index]?.to_year_edu_add}
                handleBlur={() => setFieldTouched(`additional_educations[${index}].to_year_edu_add`, true)}
                errorMessage={errors?.additional_educations?.[index]?.to_year_edu_add}
                required={
                  (addEdu.from_month_edu_add || addEdu.from_year_edu_add || addEdu.to_month_edu_add || addEdu.to_year_edu_add) && !addEdu.still_learning_add
                }
                handleChange={e => {
                  handleChange(e, index);
                  setFieldValue(`additional_educations[${index}].still_learning_add`, false);
                }}
              />
            </div>
          </div>
          <InputCheckbox
            checked={addEdu.still_learning_add}
            label={t('jobseekerEditProfile.stillLearning')}
            name={`additional_educations[${index}].still_learning_add`}
            handleChange={e => {
              const isChecked = e.target.checked;

              setFieldValue(`additional_educations[${index}].still_learning_add`, isChecked);

              if (isChecked) {
                setFieldValue(`additional_educations[${index}].to_year_edu_add`, '');
                setFieldValue(`additional_educations[${index}].to_month_edu_add`, '');
              }
            }}
          />
        </div>
      </div>
      <div className={`${additional_educations.length > 1 && index < additional_educations.length - 1 && 'mb-5'} row`}>
        <div className='removeButtonJobseeker'>
          <button
            type='button'
            className='btn btn-primary button2'
            disabled={additional_educations.length === 1}
            onClick={() => handleRemoveItem('additional_educations', index, remove)}
          >
            {t('jobseekerEditProfile.removeButton')}
          </button>
          {
            index === additional_educations.length - 1 && (
              <button
                type='button'
                className='btn btn-primary button1'
                onClick={() => handleAddItem('additional_educations', push)}
              >
                {t('jobseekerEditProfile.addMoreButton')}
              </button>
            )
          }
        </div>
      </div>
      {additional_educations.length > 1 && index < additional_educations.length - 1 && <hr />}
    </div>
  );
};

const EducationInfoBlock = ({
  errors,
  values,
  touched,
  faculties,
  directories,
  handleChange,
  setFaculties,
  // setFieldError,
  setFieldValue,
  setFieldTouched,
}) => {
  const { width } = useWindowSize();
  const { t } = useTranslation('global');
  const tokenKey = Cookies.get('tokenClient');

  const initialEducations = {
    faculty: '',
    edu_type: '',
    specialty: '',
    institution: '',
    to_year_edu: '',
    to_month_edu: '',
    from_year_edu: '',
    still_learning: 0,
    from_month_edu: '',
  };

  const initialAdditionalEducations = {
    certificate: '',
    course_link: '',
    course_name: '',
    diploma_type: '',
    institution_add: '',
    to_year_edu_add: '',
    to_month_edu_add: '',
    from_year_edu_add: '',
    from_month_edu_add: '',
    still_learning_add: '',
  };

  const { educations = [], additional_educations = [] } = values;
  const { months = [], yearList = [], education_level = [] } = directories;

  // const [prevValues, setPrevValues] = useState({ specialty: [], institution: [] });

  const getInstitutionOptions = async (inputValue, index) => {
    if (inputValue.length < 2) {
      return [];
    }

    try {
      const response = await axios.post(
        BaseApi + '/candidates/getInstitutions',
        {
          query: inputValue,
          education_level: educations[index]?.edu_type,
        },
        {
          headers: {
            key: ApiKey,
            token: tokenKey,
            'Content-Type': 'application/json',
          },
        },
      );

      if (response.data.response?.length === 0) {
        throw new Error('No options found');
      }

      const options = response.data.response.map(institution => ({
        value: institution.id,
        label: institution.name,
      }));

      return [
        ...options,
        { value: inputValue, label: inputValue },
      ];
    } catch (error) {
      console.error('Error fetching cities:', error);

      return [{ value: inputValue, label: inputValue }];
    }
  };

  const getFacultyOptions = async (id, index) => {
    if (!id) {
      setFaculties(prevState => {
        const newFaculties = [...prevState];
        newFaculties[index] = [];

        return newFaculties;
      });

      setFieldValue(`educations[${index}].faculty`, '');

      return;
    }

    setFaculties(prevState => {
      const newFaculties = [...prevState];
      newFaculties[index] = [];

      return newFaculties;
    });

    setFieldValue(`educations[${index}].faculty`, '');

    try {
      const faculties = await axios.post(
        BaseApi + '/candidates/getFaculties',
        { institution_id: id },
        {
          headers: {
            key: ApiKey,
            token: tokenKey,
            'Content-Type': 'application/json',
          },
        },
      );

      const options = faculties.data.response.map(faculty => ({
        value: faculty.id,
        label: faculty.name,
      }));

      setFaculties(prevState => {
        const newFaculties = [...prevState];
        newFaculties[index] = options;

        return newFaculties;
      });
    } catch (error) {
      console.error('Error fetching faculties:', error);

      return [];
    }
  };

  const getSpecialtyOptions = async (inputValue, index) => {
    if (inputValue.length < 2) {
      return [];
    }

    try {
      const response = await axios.post(
        BaseApi + '/candidates/getSpecialties',
        {
          query: inputValue,
          institution_id: educations[index]?.institution.value,
        },
        {
          headers: {
            key: ApiKey,
            token: tokenKey,
            'Content-Type': 'application/json',
          },
        },
      );

      if (response.data.response?.length === 0) {
        throw new Error('No options found');
      }

      const options = response.data.response.map(position => ({
        value: position.id,
        label: position.name,
      }));

      return [
        ...options,
        { value: inputValue, label: inputValue },
      ];
    } catch (error) {
      console.error('Error fetching cities:', error);

      return [{ value: inputValue, label: inputValue }];
    }
  };

  // const handleFocus = async (field, index) => {
  //   setPrevValues(prevState => {
  //     const newPrevState = { ...prevState };
  //     if (!newPrevState[field][index]) {
  //       newPrevState[field][index] = educations[index][field] || '';
  //     }

  //     return newPrevState;
  //   });

  //   await setFieldValue(`educations[${index}].${field}`, '');
  //   await setFieldError(`educations[${index}].${field}`, '');
  // };

  // const handleBlur = async (field, index) => {
  //   if (!educations[index][field]) {
  //     await setFieldValue(`educations[${index}].${field}`, prevValues[field][index]);
  //   }
  // };

  const handleAddItem = (type, push) => {
    if (type === 'educations') {
      push(initialEducations);
    } else {
      push(initialAdditionalEducations);
    }
  };

  const handleFieldChange = (field, selectedOption, index) => {
    if (field === 'institution') {
      setFieldValue(`educations[${index}].specialty`, '');
    }

    setFieldValue(`educations[${index}][${field}]`, selectedOption);
  };

  const handleRemoveItem = (type, index, remove) => {
    if (type === 'educations') {
      remove(index);
      setFaculties(prevState => prevState.filter((_, i) => i !== index));
    } else {
      remove(index);
    }
  };

  const handleFileUpload = async (e, index) => {
    const file = e.target.files[0];

    if (!file)  return;

    const base64 = await convertToBase64(file);

    if (file.size >= 5 * 1024 * 1024) {
      setFieldValue(`additional_educations[${index}].certificate`, base64);

      return;
    } else {
      setFieldValue(`additional_educations[${index}].certificate`, base64);
    }
  };

  const handleFileRemove = index => {
    const fileInput = document.querySelector(`[name="additional_educations[${index}].certificate"]`);

    if (fileInput) {
      fileInput.value = '';
    }

    setFieldValue(`additional_educations[${index}].certificate`, '');
  };

  const debouncedGetSpecialtyOptions = debounceAsync(getSpecialtyOptions, 500);
  const debouncedGetInstitutionOptions = debounceAsync(getInstitutionOptions, 500);

  useEffect(() => {
    if (width >= 768) {
      window.scrollTo({ top: 350, behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 650, behavior: 'smooth' });
    }
  }, [width]);

  return (
    <>
      <div className='mt-4 mb-4'>
        <FieldArray
          name='educations'
          render={({ push, remove }) => (
            educations.map((i, index) => (
              <div key={index}>
                <SelectWithIdInOptions
                  required
                  value={i.edu_type}
                  name={`educations[${index}].edu_type`}
                  options={transformArray(education_level)}
                  error={errors?.educations?.[index]?.edu_type}
                  className={`${index === 0 ? 'mt-4' : 'mt-5'}`}
                  touched={touched?.educations?.[index]?.edu_type}
                  label={t('jobseekerEditProfile.educationalDegree')}
                  errorMessage={errors?.educations?.[index]?.edu_type}
                  defaultOption={t('jobseekerEditProfile.selectEducationalDegree')}
                  handleBlur={() => setFieldTouched(`educations[${index}].edu_type`, true)}
                  handleChange={e => {
                    handleChange(e, index);
                    setFieldValue(`educations[${index}].institution`, '');
                    setFieldValue(`educations[${index}].faculty`, '');
                    setFieldValue(`educations[${index}].specialty`, '');
                  }}
                />
                <AsyncSelectReact
                  required
                  isClearable
                  value={i.institution}
                  name={`educations[${index}].institution`}
                  label={t('jobseekerEditProfile.institution')}
                  error={errors?.educations?.[index]?.institution}
                  touched={touched?.educations?.[index]?.institution}
                  loadingMessage={() => t('jobseekerEditProfile.pleaseWait')}
                  placeholder={t('jobseekerEditProfile.enterInstitutionName')}
                  loadOptions={value => debouncedGetInstitutionOptions(value, index)}
                  noOptionsMessage={
                    ({ inputValue }) => inputValue.length >= 2
                      ? t('jobseekerEditProfile.noOptionsFound')
                      : t('jobseekerEditProfile.enterInstitutionName')
                  }
                  // handleFocus={() => {
                  //   if (width >= 1200) {
                  //     handleFocus('institution', index);
                  //   }
                  // }}
                  handleChange={
                    selectedOption => {
                      handleFieldChange('institution', selectedOption, index);
                      i.edu_type !== '7' && getFacultyOptions(selectedOption?.value, index);
                    }
                  }
                  handleBlur={() => {
                    // if (width >= 1200) {
                    //   handleBlur('institution', index);
                    // }

                    setTimeout(() => {
                      setFieldTouched(`educations[${index}].institution`, true);
                    }, 200);
                  }}
                />
                <SelectReactWithTextManualEntry
                  required
                  isClearable
                  isSearchable
                  value={i.faculty}
                  name={`educations[${index}].faculty`}
                  label={t('jobseekerEditProfile.faculty')}
                  error={errors?.educations?.[index]?.faculty}
                  touched={touched?.educations?.[index]?.faculty}
                  placeholder={t('jobseekerEditProfile.selectFaculty')}
                  handleBlur={() => setFieldTouched(`educations[${index}].faculty`, true)}
                  handleChange={selectedOption => handleFieldChange('faculty', selectedOption, index)}
                  options={faculties[index]?.map(i => (i)) || directories?.faculties[index]?.map(i => (i))}
                  noOptionsMessage={
                    () => i.institution
                      ? t('jobseekerEditProfile.noOptionsFound')
                      : t('jobseekerEditProfile.selectInstitutionFirst')
                  }
                />
                <AsyncSelectReact
                  // required
                  isClearable
                  value={i.specialty}
                  name={`educations[${index}].specialty`}
                  label={t('jobseekerEditProfile.specialty')}
                  error={errors?.educations?.[index]?.specialty}
                  touched={touched?.educations?.[index]?.specialty}
                  placeholder={t('jobseekerEditProfile.enterSpecialtyName')}
                  loadingMessage={() => t('jobseekerEditProfile.pleaseWait')}
                  loadOptions={value => debouncedGetSpecialtyOptions(value, index)}
                  handleChange={selectedOption => handleFieldChange('specialty', selectedOption, index)}
                  noOptionsMessage={
                    ({ inputValue }) => inputValue.length >= 2
                      ? t('jobseekerEditProfile.noOptionsFound')
                      : t('jobseekerEditProfile.enterSpecialtyName')
                  }
                  // handleFocus={() => {
                  //   if (width >= 1200) {
                  //     handleFocus('specialty', index);
                  //   }
                  // }}
                  handleBlur={() => {
                    // if (width >= 1200) {
                    //   handleBlur('specialty', index);
                    // }

                    setTimeout(() => {
                      setFieldTouched(`experiences[${index}].specialty`, true);
                    }, 200);
                  }}
                />
                <div className='form-outline mb-4 DashBoardInputBx'>
                  <div className='row'>
                    <div className='col-lg-6'>
                      <p className='mb-4'>
                        {t('jobseekerEditProfile.startOfEducation')}
                      </p>
                      <div className='row'>
                        <SelectWithIdInOptions
                          // required
                          options={months}
                          className='col-lg-6'
                          value={i.from_month_edu}
                          label={t('jobseekerEditProfile.month')}
                          handleChange={e => handleChange(e, index)}
                          name={`educations[${index}].from_month_edu`}
                          error={errors?.educations?.[index]?.from_month_edu}
                          defaultOption={t('jobseekerEditProfile.selectMonth')}
                          touched={touched?.educations?.[index]?.from_month_edu}
                          errorMessage={errors?.educations?.[index]?.from_month_edu}
                          handleBlur={() => setFieldTouched(`educations[${index}].from_month_edu`, true)}
                        />
                        <Select
                          required
                          options={yearList}
                          className='col-lg-6'
                          value={i.from_year_edu}
                          label={t('jobseekerEditProfile.year')}
                          handleChange={e => handleChange(e, index)}
                          name={`educations[${index}].from_year_edu`}
                          error={errors?.educations?.[index]?.from_year_edu}
                          defaultOption={t('jobseekerEditProfile.selectYear')}
                          touched={touched?.educations?.[index]?.from_year_edu}
                          errorMessage={errors?.educations?.[index]?.from_year_edu}
                          handleBlur={() => setFieldTouched(`educations[${index}].from_year_edu`, true)}
                        />
                      </div>
                    </div>
                    <div className='col-lg-6'>
                      <p className='mb-4'>
                        {t('jobseekerEditProfile.endOfEducation')}
                      </p>
                      <div className='row'>
                        <SelectWithIdInOptions
                          options={months}
                          className='col-lg-6'
                          value={i.to_month_edu}
                          // required={!i.still_learning}
                          label={t('jobseekerEditProfile.month')}
                          name={`educations[${index}].to_month_edu`}
                          error={errors?.educations?.[index]?.to_month_edu}
                          touched={touched?.educations?.[index]?.to_month_edu}
                          defaultOption={t('jobseekerEditProfile.selectMonth')}
                          errorMessage={errors?.educations?.[index]?.to_month_edu}
                          handleBlur={() => setFieldTouched(`educations[${index}].to_month_edu`, true)}
                          handleChange={e => {
                            handleChange(e, index);
                            setFieldValue(`educations[${index}].still_learning`, false);
                          }}
                        />
                        <Select
                          options={yearList}
                          className='col-lg-6'
                          value={i.to_year_edu}
                          required={!i.still_learning}
                          label={t('jobseekerEditProfile.year')}
                          name={`educations[${index}].to_year_edu`}
                          error={errors?.educations?.[index]?.to_year_edu}
                          touched={touched?.educations?.[index]?.to_year_edu}
                          defaultOption={t('jobseekerEditProfile.selectYear')}
                          errorMessage={errors?.educations?.[index]?.to_year_edu}
                          handleBlur={() => setFieldTouched(`educations[${index}].to_year_edu`, true)}
                          handleChange={e => {
                            handleChange(e, index);
                            setFieldValue(`educations[${index}].still_learning`, false);
                          }}
                        />
                      </div>
                    </div>
                    <InputCheckbox
                      checked={i.still_learning}
                      name={`educations[${index}].still_learning`}
                      label={t('jobseekerEditProfile.stillLearning')}
                      handleChange={e => {
                        const isChecked = e.target.checked;

                        setFieldValue(`educations[${index}].still_learning`, isChecked);

                        if (isChecked) {
                          setFieldValue(`educations[${index}].to_year_edu`, '');
                          setFieldValue(`educations[${index}].to_month_edu`, '');
                        }
                      }}
                    />
                  </div>
                  <div className={`${educations.length > 1 && index < educations.length - 1 && 'mb-5'} row`}>
                    <div className='removeButtonJobseeker'>
                      <button
                        type='button'
                        disabled={educations.length === 1}
                        className='btn btn-primary button2'
                        onClick={() => handleRemoveItem('educations', index, remove)}
                      >
                        {t('jobseekerEditProfile.removeButton')}
                      </button>
                      {
                        index === educations.length - 1 && (
                          <button
                            type='button'
                            className='btn btn-primary button1'
                            onClick={() => handleAddItem('educations', push)}
                          >
                            {t('jobseekerEditProfile.addMoreButton')}
                          </button>
                        )
                      }
                    </div>
                  </div>
                </div>
                {educations.length > 1 && index < educations.length - 1 && <hr />}
              </div>
            ))
          )}
        />
      </div>
      <h4 className='mb-4'>{t('jobseekerEditProfile.additionalEducation')}</h4>
      <div className='mb-5'>
        <FieldArray
          name='additional_educations'
          render={({ push, remove }) => (
            additional_educations.map((addEdu, index) => (
              <AdditionalEducationComponent
                t={t}
                key={index}
                push={push}
                index={index}
                addEdu={addEdu}
                errors={errors}
                months={months}
                remove={remove}
                touched={touched}
                yearList={yearList}
                handleChange={handleChange}
                handleAddItem={handleAddItem}
                setFieldValue={setFieldValue}
                setFieldTouched={setFieldTouched}
                handleFileRemove={handleFileRemove}
                handleFileUpload={handleFileUpload}
                handleRemoveItem={handleRemoveItem}
                additional_educations={additional_educations}
              />
            ))
          )}
        />
      </div>
    </>
  );
};

export default EducationInfoBlock;

function convertToBase64(file) {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      resolve(fileReader.result);
    };
    fileReader.onerror = error => {
      reject(error);
    };
  });
}
